export default __webpack_public_path__ + "static/media/TrialUserWordTemplate.7898bad3.png";